// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2lkLa","dragIcon":"Choice_dragIcon__2JO6z","left":"Choice_left__3zZDP","input":"Choice_input__1jQd-"};